import { Typography } from '@vp/swan'
import { useSelector } from 'react-redux'
import { useContext } from 'react'
import { getShowSets } from '~/client/store/debug'
import { SetChip } from '~/client/components/Gallery/SetHighlighting/SetChip'
import { SetHighlightingContext } from '~/client/components/Gallery/SetHighlighting/SetHighlightingContext'

export const SetHighlightingHeader = () => {
  const showSets = useSelector(getShowSets)
  const context = useContext(SetHighlightingContext)
  const setColorMap = context?.setColorMap || new Map()

  if (!showSets || setColorMap.size === 0) {
    return null
  }

  return (
    <div className="set-highlighting-header">
      <Typography fontSize="xlarge" fontWeight="bold">
        Ranking Sets Legend:{' '}
      </Typography>
      <div className="set-highlighting-header__chips">
        {Array.from(setColorMap.entries())
          .sort((a, b) => a[0].localeCompare(b[0]))
          .map(([setName, color]) => (
            <SetChip color={color} key={setName} setName={setName} />
          ))}
      </div>
    </div>
  )
}
